var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"name-bubble",class:{
        'no-brightness': _vm.hovered === true,
        'put-emphasis': _vm.PutEmphasis === true,
        'no-put-emphasis': _vm.PutEmphasis === false,
    },style:({ 
        color: 'white', 
        backgroundColor: _vm.hovered ? 'rgba(210, 82, 31, .9)' : _vm.bgColor ,
        'min-width': `${_vm.Radius}px`,
        'max-width': `${_vm.Radius}px`,
        'min-height': `${_vm.Radius}px`,
        'max-height': `${_vm.Radius}px`,
    }),on:{"mouseover":() => _vm.handleHover(true),"mouseleave":() => _vm.handleHover(false),"click":function($event){return _vm.clickBubble()}}},[(!_vm.hovered)?_c('div',[_vm._v("\n        "+_vm._s(_vm.text)+"\n    ")]):_c('div',[_c('i',{staticClass:"fa-solid fa-xmark"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }